module.exports = __webpack_public_path__ + "static/media/ieeevis-18-original.b41395ca.jpg";